export function getDomainForCookie(): string {
    const [topLevelDomain, secondLevelDomain] = document.domain
        .split('.')
        .reverse();
    const domainForCookie =
        topLevelDomain.toLowerCase() === 'localhost'
            ? 'localhost'
            : `.${secondLevelDomain}.${topLevelDomain}`;
    return domainForCookie;
}
